import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { compose, withProps } from 'recompose'

import {
  updateListTitle,
  updateListDescription,
  createTodo,
  updateTodoCompletion,
  updateTodoTitle,
  deleteTodo,
  copyTodoList
} from '../firebase'

import * as actionCreators from '../actions/actionCreators'
import * as thunks from '../actions/thunks'

import CreatorListEditor from './CreatorListEditor'
import LoadingScreen from './LoadingScreen'
import StudentTodoView from './StudentTodoView'

class TodoViewLoader extends React.Component {
  render () {
    if (
      this.props.listInfo.listId === '' ||
      this.props.firestore.isInitializing
    ) {
      return <LoadingScreen />
    }

    const { viewType } = this.props.listInfo

    if (viewType === 'DEFAULT') {
      return (
        <CreatorListEditor
          todos={this.props.todos}
          listInfo={this.props.listInfo}
          matchListId={this.props.match.params.listId}
          createTodo={this.props.createTodo}
          updateListTitle={this.props.updateListTitle}
          updateListDescription={this.props.updateListDescription}
          updateTodoCompletion={this.props.updateTodoCompletion}
          updateTodoTitle={this.props.updateTodoTitle}
          deleteTodo={this.props.deleteTodo}
          copyTodoList={this.props.copyTodoList} />
      )
    } else if (viewType === 'STUDENT') {
      return (
        <StudentTodoView
          listInfo={this.props.listInfo}
          todoItems={this.props.todos.todoItems}
          highlightedTodoIndex={this.props.todos.highlightIndex}
          updateTodoCompletion={this.props.updateTodoCompletion}
          highlightTodo={this.props.highlightTodo} />
      )
    }
  }

  componentDidMount () {
    if (this.props.listInfo.listId === '') {
      this.props.initializeTodoApp(this.props.match.params.listId)
    }
  }
}

function mapStateToProps (state) {
  return {
    todos: state.todos,
    listInfo: state.listInfo,
    firestore: state.firestore
  }
}

function mapDispatchToProps (dispatch) {
  return bindActionCreators({ ...actionCreators, ...thunks }, dispatch)
}
/* does the following achieve the same effect?
function mapDispatchToProps(dispatch){
  return actionCreators;
}
*/

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  withProps({
    updateListTitle,
    updateListDescription,
    createTodo,
    updateTodoCompletion,
    updateTodoTitle,
    deleteTodo,
    copyTodoList
  })
)(TodoViewLoader)
// export default connect(mapStateToProps, mapDispatchToProps)(TodoApp);
// export default TodoApp;



// WEBPACK FOOTER //
// ./src/components/TodoViewLoader.js